export const treatments = [
    {
        value: '术前辅助',
        label: '术前辅助',
        children: [
            {
                value: '奥沙利铂+替吉奥',
                label: '奥沙利铂+替吉奥',
            },
            {
                value: '奥沙利铂+卡培他滨',
                label: '奥沙利铂+卡培他滨',

            }
            
        ],
    },
    {
        value: '术后一线',
        label: '术后一线',
        children: [
            {
                value: '奥沙利铂+替吉奥',
                label: '奥沙利铂+替吉奥',
            },
            {
                value: '奥沙利铂+卡培他滨',
                label: '奥沙利铂+卡培他滨',

            },
            {
                value: '奥沙利铂+氟尿嘧啶+亚叶酸钙',
                label: '奥沙利铂+氟尿嘧啶+亚叶酸钙',

            }
        ],
    },
    {
        value: '术后二线',
        label: '术后二线',
        children: [
            {
                value: '伊立替康+替吉奥',
                label: '伊立替康+替吉奥',
            },
            {
                value: '伊立替康+卡培他滨',
                label: '伊立替康+卡培他滨',

            },
            {
                value: '伊立替康+氟尿嘧啶',
                label: '伊立替康+氟尿嘧啶',

            }
        ],
    },
    {
        value: '联合免疫治疗',
        label: '联合免疫治疗',
        children: [
            {
                value: '替雷利珠单抗',
                label: '替雷利珠单抗',
            },
            {
                value: '信迪利单抗',
                label: '信迪利单抗',
            }
            
        ],
    },
    {
        value: '联合靶向治疗',
        label: '联合靶向治疗',
        children: [
            {
                value: '曲妥珠单抗',
                label: '曲妥珠单抗',
            }           
        ],
    },
    {
        value: '术中腹腔灌注',
        label: '术中腹腔灌注',
        children: [
            {
                value: '雷替曲塞',
                label: '雷替曲塞',

            },
            {
                value: '氟尿嘧啶',
                label: '氟尿嘧啶',
            }
        ],
    }
]